
import React from "react";
import "../Privacy_Policy/Privacy_Policy.css";

const sections = [
  {
    title: "1. פרטי המשרד ותחולת המדיניות",
    content: (
      <>
        <p>
          אתר זה מופעל עבור משרד עורכי דין רז יוסף, העוסק בין היתר בדיני
          משפחה, גירושין, אחריות הורית, מזונות, חלוקת רכוש, הסכמים,
          ירושות וייפוי כוח מתמשך.
        </p>
        <p>
          מדיניות זו מסבירה כיצד עשוי להיאסף מידע אישי במסגרת השימוש באתר,
          כיצד נעשה בו שימוש, למי הוא עשוי להימסר ומהן זכויות המשתמשים.
          המדיניות חלה על השימוש באתר, על טפסי הפנייה ועל תקשורת ראשונית
          עם המשרד באמצעות ערוצים דיגיטליים, ככל שרלוונטי.
        </p>
        <p>
          פרטי המשרד: משרד עורכי דין רז יוסף, רחוב האורזים 23, נתניה.
          טלפון: 050-757-5775. דוא"ל: raz290174@gmail.com.
        </p>
      </>
    ),
  },
  {
    title: "2. הדין החל והמסגרת המשפטית",
    content: (
      <>
        <p>
          המשרד פועל בהתאם להוראות הדין החלות בישראל, ובכלל זה חוק הגנת
          הפרטיות, התשמ"א–1981, לרבות תיקון מס' 13, תקנות הגנת הפרטיות
          (אבטחת מידע), התשע"ז–2017, חוק התקשורת (בזק ושידורים),
          התשמ"ב–1982, חוק זכות יוצרים, התשס"ח–2007, חוק שוויון זכויות
          לאנשים עם מוגבלות, התשנ"ח–1998, והתקנות שהותקנו מכוחו,
          וכן הוראות דין וכללי אתיקה מקצועית החלים על עורכי דין.
        </p>
        <p>
          תחולת הוראות הדין תלויה בנסיבות הפעילות, בסוג המידע, במטרות
          השימוש ובמאפייני השירות. אין באמור כדי לגרוע מזכות או מחובה
          הקבועות בדין.
        </p>
      </>
    ),
  },
  {
    title: "3. איזה מידע אישי עשוי להיאסף?",
    content: (
      <>
        <p>בהתאם לאופן השימוש באתר ולמידע שהמשתמש בוחר למסור, עשויים להיאסף:</p>
        <ul>
          <li>שם מלא, מספר טלפון וכתובת דוא"ל.</li>
          <li>תוכן הודעות, שאלות ופניות שנשלחות למשרד.</li>
          <li>נושא הפנייה וסוג השירות המשפטי המבוקש.</li>
          <li>מידע שנמסר במסגרת תיאום פגישה או שיחת היכרות.</li>
          <li>כתובת IP, סוג מכשיר, מערכת הפעלה, דפדפן ונתוני שימוש באתר.</li>
          <li>מידע טכני הנאסף באמצעות Cookies וכלים דומים, ככל שמופעלים.</li>
          <li>מידע נוסף שהמשתמש בוחר למסור למשרד במהלך ההתקשרות.</li>
        </ul>
        <p>
          במסגרת פנייה משפטית בענייני משפחה עלול להימסר מידע רגיש במיוחד,
          לרבות מידע על זוגיות, גירושין, ילדים, מצב כלכלי, מזונות, הליכים
          משפטיים, מצב רפואי, יחסים בתוך המשפחה, כתובות מגורים ומסמכים
          משפטיים.
        </p>
        <p>
          מומלץ למסור בשלב הפנייה הראשונית רק את המידע ההכרחי לצורך יצירת
          קשר ובחינת הפנייה. אין לשלוח דרך טופס רגיל באתר מסמכים רפואיים,
          תעודות זהות, כתבי טענות, מסמכים חסויים או חומר רגיש אחר, אלא
          לאחר תיאום עם המשרד וקבלת הנחיות לגבי ערוץ העברה מתאים.
        </p>
      </>
    ),
  },
  {
    title: "4. מטרות איסוף המידע והשימוש בו",
    content: (
      <>
        <p>המידע עשוי לשמש, לפי העניין, למטרות הבאות:</p>
        <ul>
          <li>קבלת פניות ומתן מענה ראשוני.</li>
          <li>יצירת קשר עם הפונה ותיאום שיחות או פגישות.</li>
          <li>הבנת נושא הפנייה ובחינת האפשרות להעניק שירות משפטי.</li>
          <li>בדיקת ניגוד עניינים לפני קבלת טיפול או ייצוג.</li>
          <li>מתן שירות משפטי, ככל שנכרתה התקשרות עם המשרד.</li>
          <li>ניהול קשר עם לקוחות וטיפול בעניינים משפטיים.</li>
          <li>עמידה בחובות חוקיות, מקצועיות, חשבונאיות ואתיות.</li>
          <li>הגנה על זכויות המשרד, לקוחותיו והמשתמשים.</li>
          <li>תפעול האתר, אבטחתו, איתור תקלות ושיפור חוויית המשתמש.</li>
          <li>מניעת הונאות, התחזות, שימוש לרעה ופניות אוטומטיות מזיקות.</li>
        </ul>
        <p>
          המשרד לא יעשה שימוש במידע אישי למטרה שאינה מתיישבת עם מטרות
          האיסוף והוראות הדין, אלא כאשר קיימת לכך הסכמה או סמכות חוקית
          מתאימה.
        </p>
      </>
    ),
  },
  {
    title: "5. הבהרה בעת מסירת מידע והודעה לפי חוק הגנת הפרטיות",
    content: (
      <>
        <p>
          מסירת מידע באמצעות האתר נעשית ככלל מרצון המשתמש. עם זאת,
          אם המשתמש אינו מוסר פרטים הנחוצים ליצירת קשר, ייתכן שלא ניתן
          יהיה להשיב לפנייתו או לטפל בה.
        </p>
        <p>
          בעת איסוף מידע אישי יוצגו, במקום ובאופן הנדרשים לפי דין,
          פרטי ההודעה הנדרשת בחוק, לרבות זהות הגורם האוסף, מטרות האיסוף,
          האם קיימת חובה חוקית למסירת המידע או שמסירתו תלויה ברצון המשתמש
          ומהן תוצאות אי-המסירה, למי עשוי המידע להימסר ומהן זכויות המשתמש.
        </p>
        <p>
          מדיניות זו אינה מחליפה הודעת פרטיות ייעודית המוצגת לצד טופס
          איסוף מידע, כאשר הודעה כזו נדרשת לפי דין.
        </p>
        <p>
          ככל שהמשתמש מתבקש לאשר הסכמה לעיבוד מידע או לשימוש מסוים,
          ההסכמה תתבקש באופן ברור ונפרד ככל שנדרש לפי דין.
        </p>
      </>
    ),
  },
  {
    title: "6. פניות ראשוניות, ייעוץ משפטי ויחסי עורך דין–לקוח",
    content: (
      <>
        <p>
          המידע והתכנים באתר נועדו למידע כללי בלבד. שליחת טופס, הודעת
          דוא"ל, הודעת WhatsApp או ביצוע שיחת טלפון אינם מהווים כשלעצמם
          הסכם שכר טרחה, קבלת ייצוג או התחייבות של המשרד לטפל בעניין.
        </p>
        <p>
          יחסי עורך דין–לקוח ייבחנו וייווצרו בהתאם לנסיבות, לבדיקות
          הנדרשות ולהסכמה מפורשת של הצדדים, לרבות הסדרת תנאי ההתקשרות
          ככל שנדרשת.
        </p>
        <p>
          אין להניח כי המשרד קיבל על עצמו טיפול משפטי, כי נקבע מועד
          להגשת מסמך או כי ננקטה פעולה משפטית כלשהי, אלא אם הדבר אושר
          במפורש על ידי המשרד.
        </p>
        <p>
          אין לשלוח מידע רגיש בהנחה שעצם שליחתו מבטיחה חיסיון או
          התקשרות מקצועית. חובות הסודיות והחיסיון ייבחנו בהתאם לדין
          ולנסיבות המקרה.
        </p>
      </>
    ),
  },
  {
    title: "7. בדיקת ניגוד עניינים ופניות מצדדים שונים",
    content: (
      <>
        <p>
          לפני קבלת ייצוג או טיפול משפטי, המשרד עשוי להידרש לבדוק אם
          קיימת מניעה מקצועית או ניגוד עניינים.
        </p>
        <p>
          לצורך בדיקה זו עשוי המשרד לבקש פרטים מזהים בסיסיים של הצדדים
          המעורבים, כגון שמות הצדדים ושמות גורמים רלוונטיים נוספים,
          במידה הנחוצה לביצוע הבדיקה.
        </p>
        <p>
          אין למסור בשלב זה פירוט עובדתי מלא, מסמכים או מידע רגיש שאינם
          נחוצים לבדיקת ניגוד העניינים. המשרד רשאי שלא לקבל פנייה או
          שלא להמשיך בבדיקתה, בכפוף לדין ולחובותיו המקצועיות.
        </p>
        <p>
          פנייה של אדם אחד אינה מקנה לו זכות לקבל מידע על פנייה של אדם
          אחר, ואין למסור לפונה מידע על לקוח או על אדם אחר ללא בסיס
          חוקי מתאים.
        </p>
      </>
    ),
  },
  {
    title: "8. סודיות מקצועית וחיסיון עורך דין–לקוח",
    content: (
      <>
        <p>
          עורך דין כפוף לחובות סודיות מקצועית ולכללי החיסיון הקבועים
          בדין, ובכלל זה להוראות חוק לשכת עורכי הדין, התשכ"א–1961,
          ולכללי האתיקה המקצועית החלים עליו.
        </p>
        <p>
          המשרד מתייחס ברגישות מיוחדת למידע הנוגע לגירושין, סכסוכים
          משפחתיים, ילדים, אחריות הורית, זמני שהות, מזונות, רכוש,
          ירושות, אפוטרופסות ועניינים אישיים נוספים.
        </p>
        <p>
          היקף החיסיון והסודיות נקבע לפי הוראות הדין והנסיבות. אין
          במדיניות זו כדי להרחיב או לצמצם חיסיון הקבוע בחוק, או כדי
          ליצור חיסיון במקום שבו הוא אינו חל.
        </p>
        <p>
          מידע עשוי להימסר כאשר קיימת חובה או סמכות חוקית לכך, או
          בנסיבות שבהן הדין מתיר את מסירתו, ובכפוף למגבלות החלות על
          המשרד כעורך דין.
        </p>
      </>
    ),
  },
  {
    title: "9. מידע על ילדים וקטינים",
    content: (
      <>
        <p>
          פניות בתחום דיני המשפחה עשויות לכלול מידע הנוגע לקטינים,
          לרבות שמות, גילאים, מסגרות חינוכיות, זמני שהות, מצב רפואי,
          מצב משפחתי ופרטים נוספים.
        </p>
        <p>
          מידע הנוגע לקטינים יטופל בזהירות מיוחדת, בהתאם למטרת הטיפול,
          לעקרון צמצום המידע, להוראות הדין ולחובות המקצועיות החלות על
          המשרד.
        </p>
        <p>
          אין למסור דרך האתר מידע מזהה על ילדים מעבר לנדרש לצורך
          הפנייה הראשונית. ככל שנדרש מידע נוסף, המשרד ינחה כיצד
          להעבירו באופן מתאים.
        </p>
        <p>
          האתר אינו מיועד לילדים כקהל יעד, ואין למסור בו מידע אישי
          של קטין ללא סמכות או אישור מתאימים, ככל שנדרשים לפי דין.
        </p>
      </>
    ),
  },
  {
    title: "10. מסירת מידע לצדדים שלישיים",
    content: (
      <>
        <p>
          המשרד אינו מוכר מידע אישי של משתמשי האתר. מידע עשוי להימסר
          לגורמים אחרים רק במידה הנחוצה למטרות המפורטות במדיניות זו,
          לצורך מתן השירות, מכוח הסכמה מתאימה או כאשר קיימת חובה או
          סמכות חוקית למסירתו.
        </p>
        <p>לפי השירותים המופעלים בפועל, גורמים אלה עשויים לכלול:</p>
        <ul>
          <li>ספקי אחסון אתרים, שרתים ותשתיות מחשוב.</li>
          <li>ספקי דואר אלקטרוני ותקשורת.</li>
          <li>ספקי אבטחת מידע, גיבוי והגנה מפני מתקפות.</li>
          <li>ספקי טפסים, אימות משתמשים ומניעת הודעות זבל.</li>
          <li>שירותי מדידה וניתוח תנועה באתר, ככל שמופעלים.</li>
          <li>ספקי שירות טכנולוגיים המסייעים בתפעול האתר.</li>
          <li>רשויות מוסמכות, בתי משפט או גורמים אחרים כאשר הדבר נדרש לפי דין.</li>
        </ul>
        <p>
          המשרד יפעל להסדרת ההתקשרויות עם ספקים המטפלים במידע עבורו
          ולנקיטת אמצעים מתאימים להגנת המידע, בהתאם להוראות הדין.
        </p>
      </>
    ),
  },
  {
    title: "11. שירותים חיצוניים, Google, WhatsApp ו-reCAPTCHA",
    content: (
      <>
        <p>
          האתר עשוי לשלב שירותים של ספקים חיצוניים, בהתאם להגדרות
          הטכניות המופעלות בו בפועל.
        </p>
        <ul>
          <li>
            Google Analytics או שירות מדידה אחר – אם מותקן, עשוי לאסוף
            נתוני שימוש וגלישה בהתאם להגדרות השירות.
          </li>
          <li>
            Google reCAPTCHA או שירות אימות אחר – אם מופעל בטפסים,
            עשוי לעבד נתונים טכניים לצורך הבחנה בין משתמשים לבין פעילות
            אוטומטית מזיקה.
          </li>
          <li>
            WhatsApp – מעבר לשירות WhatsApp עשוי להיות כפוף לתנאי
            השימוש ולמדיניות הפרטיות של Meta ו-WhatsApp.
          </li>
          <li>
            ספקי אחסון, דוא"ל, מפות, מדיה או שירותים משולבים אחרים –
            בהתאם לרכיבים המותקנים באתר.
          </li>
        </ul>
        <p>
          לכל שירות חיצוני עשויה להיות מדיניות פרטיות עצמאית. המשרד
          אינו שולט בכל פעולות העיבוד של ספקים אלה. מומלץ לעיין
          במדיניות שלהם לפני שימוש בשירות.
        </p>
        <p>
          אין במדיניות זו הצהרה כי שירות מסוים אכן מופעל באתר בכל עת.
          יש להתאים את הרשימה לרכיבים ולספקים הפעילים בפועל.
        </p>
      </>
    ),
  },
  {
    title: "12. Cookies וטכנולוגיות דומות",
    content: (
      <>
        <p>
          האתר עשוי להשתמש בקובצי Cookies ובטכנולוגיות דומות לצורך
          תפעולו, אבטחתו, שמירת העדפות, מדידת תנועה ושיפור חוויית הגלישה.
        </p>
        <p>בין היתר, עשויים להופיע סוגי Cookies אלה:</p>
        <ul>
          <li>Cookies חיוניים הדרושים להפעלה תקינה של האתר.</li>
          <li>Cookies לשמירת העדפות משתמש.</li>
          <li>Cookies למדידה וניתוח נתוני גלישה, אם מופעלים.</li>
          <li>Cookies של שירותים חיצוניים המשולבים באתר, אם מופעלים.</li>
        </ul>
        <p>
          ניתן לחסום או למחוק Cookies דרך הגדרות הדפדפן. חסימה של
          Cookies מסוימים עלולה לפגוע בחלק מתפקודי האתר.
        </p>
        <p>
          ככל שנדרשת הסכמה לפני שימוש בטכנולוגיות מסוימות, השימוש
          ייעשה בכפוף לקבלת הסכמה מתאימה. הודעה כללית על Cookies
          אינה מחליפה מנגנון הסכמה כאשר הדין מחייב אותו.
        </p>
      </>
    ),
  },
  {
    title: "13. העברת מידע מחוץ לישראל",
    content: (
      <>
        <p>
          חלק מספקי השירותים הטכנולוגיים עשויים לאחסן או לעבד מידע
          בשרתים הנמצאים מחוץ לישראל.
        </p>
        <p>
          ככל שמידע אישי מועבר מחוץ לישראל, ההעברה תיבחן ותבוצע
          בהתאם להוראות הדין החלות על העברת מידע אישי אל מחוץ לגבולות
          המדינה, לרבות התקנות הרלוונטיות.
        </p>
        <p>
          זהות המדינות והספקים הרלוונטיים תלויה בשירותים שבהם נעשה
          שימוש בפועל.
        </p>
      </>
    ),
  },
  {
    title: "14. אבטחת מידע",
    content: (
      <>
        <p>
          המשרד פועל לנקיטת אמצעי אבטחה סבירים ומקובלים להגנה על מידע
          אישי, בהתאם לרגישות המידע, להיקף עיבודו, לסיכונים ולהוראות
          הדין החלות.
        </p>
        <p>אמצעי ההגנה עשויים לכלול, לפי העניין:</p>
        <ul>
          <li>הגבלת הרשאות גישה למידע לפי הצורך.</li>
          <li>שימוש בסיסמאות ובאמצעי אימות מתאימים.</li>
          <li>עדכון תוכנות ורכיבי האתר.</li>
          <li>אמצעי הגנה על שרתים, מערכות וחשבונות.</li>
          <li>גיבוי מידע וניהול הרשאות לספקים חיצוניים.</li>
          <li>טיפול באירועי אבטחה בהתאם לחובות הדין.</li>
        </ul>
        <p>
          אין אפשרות להבטיח אבטחה מוחלטת של מערכות מידע או העברת
          מידע באינטרנט. המשתמש מתבקש להימנע משליחת מידע רגיש בערוץ
          שאינו מתאים לכך.
        </p>
        <p>
          במקרה של אירוע אבטחת מידע, המשרד יפעל בהתאם להוראות הדין
          החלות, לרבות חובות דיווח או הודעה ככל שהן מתקיימות.
        </p>
      </>
    ),
  },
  {
    title: "15. שמירת מידע, תיעוד ומחיקה",
    content: (
      <>
        <p>
          מידע אישי יישמר לפרק הזמן הנדרש למטרות שלשמן נאסף, לצורך
          ניהול פנייה או טיפול משפטי, עמידה בחובות חוקיות ומקצועיות,
          ניהול תיעוד והגנה על זכויות המשרד והלקוחות.
        </p>
        <p>
          תקופת השמירה תיקבע בהתאם לסוג המידע, לאופי הקשר עם הפונה,
          להוראות הדין ולצורך הלגיטימי בהמשך שמירתו.
        </p>
        <p>
          בתום תקופת השמירה, מידע יימחק או יעבור הליך מתאים של צמצום
          או התממה, ככל שהדבר אפשרי ומותר לפי דין. ייתכן שמידע מסוים
          יישמר גם לאחר סיום הטיפול כאשר קיימת חובה חוקית או הצדקה
          משפטית מתאימה לכך.
        </p>
      </>
    ),
  },
  {
    title: "16. זכויות המשתמשים במידע",
    content: (
      <>
        <p>
          בהתאם לחוק הגנת הפרטיות ולהוראות הדין, אדם עשוי להיות זכאי
          לעיין במידע אישי המתייחס אליו והמוחזק במאגר מידע, וכן לבקש
          תיקון או מחיקה כאשר מתקיימים התנאים הקבועים בחוק.
        </p>
        <p>
          בקשה לעיון, תיקון או מחיקה תוגש למשרד בפרטי ההתקשרות
          המופיעים בעמוד זה. המשרד רשאי לבקש פרטים סבירים לצורך
          אימות זהות המבקש ובדיקת זכאותו.
        </p>
        <p>
          הבקשה תיבחן בהתאם להוראות הדין. הזכויות אינן מוחלטות,
          ובנסיבות מסוימות עשויות לחול מגבלות או חריגים, לרבות
          חובות שמירת מסמכים, זכויות צדדים שלישיים וחובות מקצועיות.
        </p>
      </>
    ),
  },
  {
    title: "17. דיוור, הודעות ופרסומות",
    content: (
      <>
        <p>
          המשרד עשוי לשלוח הודעות הנוגעות לפנייה שהתקבלה או לשירות
          שהתבקש, כאשר הדבר נדרש לצורך הטיפול בפנייה או בקשר המקצועי.
        </p>
        <p>
          משלוח דברי פרסומת או הודעות שיווקיות ייעשה בהתאם להוראות
          חוק התקשורת (בזק ושידורים), התשמ"ב–1982, ולכל דין רלוונטי.
          ככל שנדרשת הסכמה מראש, היא תתקבל בנפרד ובאופן מתאים.
        </p>
        <p>
          בהודעות פרסומיות תינתן אפשרות להסרה בהתאם להוראות הדין.
          ניתן לפנות למשרד בבקשה להפסיק קבלת הודעות שיווקיות.
        </p>
        <p>
          עצם הפנייה למשרד או קבלת שירות משפטי אינם מהווים כשלעצמם
          הסכמה לקבלת פרסומות.
        </p>
      </>
    ),
  },
  {
    title: "18. שימוש באתר, אחריות והסתייגות מייעוץ משפטי",
    content: (
      <>
        <p>
          האתר והתכנים המופיעים בו נועדו למידע כללי בלבד ואינם מהווים
          ייעוץ משפטי, חוות דעת משפטית, המלצה לפעולה או תחליף לייעוץ
          פרטני המבוסס על מלוא נסיבות המקרה.
        </p>
        <p>
          אין להסתמך על מידע באתר לצורך קבלת החלטה משפטית, נקיטת הליך,
          הימנעות מהליך או החמצת מועד. יש לפנות לקבלת ייעוץ משפטי
          פרטני לפני פעולה המבוססת על נסיבות אישיות.
        </p>
        <p>
          הדין, הפסיקה והנהלים עשויים להשתנות. המשרד אינו מתחייב
          שהתכנים באתר מעודכנים בכל רגע נתון או שהם כוללים את כל
          ההיבטים הרלוונטיים לכל מקרה.
        </p>
        <p>
          המשרד עושה מאמצים להציג מידע ברור ומדויק, אך אינו מתחייב
          שהאתר יהיה זמין ללא הפרעות, תקלות או שגיאות.
        </p>
        <p>
          אין באמור כדי לשלול אחריות שלא ניתן לשלול לפי דין או לגרוע
          מזכויות המוקנות למשתמש על פי חוק.
        </p>
      </>
    ),
  },
  {
    title: "19. פניות דחופות ומועדים משפטיים",
    content: (
      <>
        <p>
          אין להשתמש באתר, בטופס יצירת הקשר או בדוא"ל כערוץ יחיד
          לטיפול במקרה דחוף, לצורך הגשת מסמך לבית משפט או בית דין,
          לשמירת מועד להגשת הליך או לקבלת סעד דחוף.
        </p>
        <p>
          שליחת פנייה אינה מבטיחה כי המשרד קיבל אותה, קרא אותה או
          יוכל לטפל בה במועד. אין להניח כי ננקטה פעולה משפטית בעקבות
          שליחת הודעה.
        </p>
        <p>
          במקרה של מועד משפטי קרוב או צורך בסעד דחוף, יש לוודא
          התקשרות ישירה עם עורך דין ולפעול לשמירת הזכויות והמועדים
          בהתאם לנסיבות.
        </p>
      </>
    ),
  },
  {
    title: "20. זכויות יוצרים וקניין רוחני",
    content: (
      <>
        <p>
          זכויות היוצרים והקניין הרוחני בתכנים מקוריים באתר, לרבות
          טקסטים, עיצוב, תמונות, גרפיקה וסימנים, שייכות לבעלי הזכויות
          הרלוונטיים.
        </p>
        <p>
          אין להעתיק, לשכפל, לפרסם, להפיץ, לשנות או לעשות שימוש
          מסחרי בתכני האתר ללא קבלת אישור מראש ובכתב מבעל הזכויות,
          למעט שימוש המותר לפי דין.
        </p>
        <p>
          סימנים, תמונות או תכנים של צדדים שלישיים כפופים לזכויות
          בעליהם ולתנאי השימוש החלים עליהם.
        </p>
      </>
    ),
  },
  {
    title: "21. קישורים ושירותים של צדדים שלישיים",
    content: (
      <>
        <p>
          האתר עשוי לכלול קישורים לאתרים חיצוניים או לשירותים שאינם
          מופעלים על ידי המשרד. מעבר לאתר חיצוני נעשה באחריות המשתמש,
          והשימוש בו כפוף לתנאי השימוש ולמדיניות הפרטיות של אותו גורם.
        </p>
        <p>
          המשרד אינו אחראי לתוכן, לזמינות או למדיניות הפרטיות של
          אתרים חיצוניים שאינם בשליטתו.
        </p>
      </>
    ),
  },
  {
    title: "22. נגישות האתר והשירות במשרד",
    content: (
      <>
        <p>
          המשרד מכיר בחשיבות הנגישות ופועל בהתאם להוראות חוק שוויון
          זכויות לאנשים עם מוגבלות והתקנות הרלוונטיות, ככל שהן חלות
          על האתר ועל השירות הניתן לציבור.
        </p>
        <p>
          מידע על התאמות הנגישות שבוצעו בפועל באתר ובמשרד, אמצעי
          הנגישות הקיימים ודרכי פנייה לקבלת התאמה יופיע בהצהרת
          הנגישות של המשרד.
        </p>
        <p>
          ניתן לפנות למשרד בטלפון 050-757-5775 או בדוא"ל
          raz290174@gmail.com כדי לדווח על קושי בנגישות או לבקש
          סיוע. יש להתאים את פרטי רכז הנגישות וההתאמות המפורסמים
          באתר למצב בפועל.
        </p>
        <p>
          קיומו של תוסף נגישות או סרגל נגישות אינו מהווה כשלעצמו
          אישור לכך שהאתר עומד בכל דרישות הנגישות.
        </p>
      </>
    ),
  },
  {
    title: "23. הגבלת שימוש אסור באתר",
    content: (
      <>
        <p>המשתמש מתחייב שלא לעשות שימוש באתר לצורך:</p>
        <ul>
          <li>פעילות בלתי חוקית או פגיעה בזכויות אחרים.</li>
          <li>העברת מידע כוזב, התחזות או פגיעה במשתמשים אחרים.</li>
          <li>ניסיון לחדור למערכות האתר או לשבש את פעילותו.</li>
          <li>הפצת קוד זדוני, תוכנות מזיקות או הודעות אוטומטיות מזיקות.</li>
          <li>איסוף מידע מהאתר או שימוש בתכניו בניגוד לדין.</li>
        </ul>
        <p>
          המשרד רשאי לנקוט צעדים סבירים להגנה על האתר ועל זכויותיו,
          בכפוף להוראות הדין.
        </p>
      </>
    ),
  },
  {
    title: "24. שינויים במדיניות",
    content: (
      <>
        <p>
          המשרד רשאי לעדכן מדיניות זו מעת לעת, בין היתר בעקבות
          שינויים בדין, בשירותי האתר, באמצעי איסוף המידע או בפעילות
          המשרד.
        </p>
        <p>
          הנוסח המעודכן יפורסם בעמוד זה. כאשר שינוי מחייב הודעה
          או קבלת הסכמה לפי דין, המשרד יפעל בהתאם לדרישה הרלוונטית.
        </p>
      </>
    ),
  },
  {
    title: "25. דין וסמכות שיפוט",
    content: (
      <>
        <p>
          על השימוש באתר ועל מדיניות זו יחולו דיני מדינת ישראל,
          בכפוף להוראות דין קוגנטיות ולהוראות סמכות שיפוט שאינן
          ניתנות להתניה.
        </p>
        <p>
          אין בסעיף זה כדי לגרוע מזכות או מסמכות של ערכאה שיפוטית
          המוקנית לפי דין.
        </p>
      </>
    ),
  },
];

const Privacy_Policy = () => {
  return (
    <main className="Privacy_Policy-page" dir="rtl">
      <section className="Privacy_Policy-hero">
        <div className="Privacy_Policy-overlay">
          <h1>מדיניות פרטיות ותנאי שימוש</h1>
        </div>
      </section>

      <section className="page3">
        <div className="container">
          <div className="text-box privacy-intro">
            <h2 className="main-title">שמירה על פרטיותך ועל זכויותיך</h2>
            <p>
              משרד עורכי דין רז יוסף מייחס חשיבות לשמירה על פרטיות
              המשתמשים באתר ועל מידע אישי הנמסר במסגרת פנייה למשרד.
              מדיניות זו מפרטת את אופן הטיפול במידע ואת תנאי השימוש באתר.
            </p>
            <p>
              מאחר שהמשרד עוסק בדיני משפחה, פניות עשויות לכלול מידע
              אישי, משפחתי ומשפטי רגיש במיוחד. אנו מבקשים מהפונים
              לנהוג בזהירות ולא להעביר מידע או מסמכים רגישים בערוץ
              שאינו מתאים לכך.
            </p>
            <p className="privacy-important">
              חשוב: שליחת פנייה דרך האתר אינה מהווה כשלעצמה קבלת
              ייצוג משפטי, יצירת יחסי עורך דין–לקוח או אישור לכך
              שהמשרד קיבל על עצמו לטפל בעניין.
            </p>
          </div>

          <nav className="privacy-contents" aria-label="תוכן העניינים">
            <h2>תוכן העניינים</h2>
            <ol>
              {sections.map((section, index) => (
                <li key={section.title}>
                  <a href={`#privacy-section-${index + 1}`}>
                    {section.title}
                  </a>
                </li>
              ))}
              <li>
                <a href="#privacy-contact">פרטי קשר</a>
              </li>
            </ol>
          </nav>

          {sections.map((section, index) => (
            <section
              className="text-box privacy-section"
              id={`privacy-section-${index + 1}`}
              key={section.title}
            >
              <h2 className="main-title">{section.title}</h2>
              <div className="privacy-section-content">
                {section.content}
              </div>
            </section>
          ))}

          <section
            className="text-box privacy-section privacy-contact"
            id="privacy-contact"
          >
            <h2 className="main-title">26. יצירת קשר ופניות בנושא פרטיות</h2>
            <p>
              לכל שאלה, בקשה לעיון במידע, בקשה לתיקון מידע או פנייה
              אחרת הנוגעת לפרטיות, ניתן ליצור קשר עם המשרד:
            </p>
            <div className="bottom-text">
   
              <p>
                <a href="/ContactSection2">לעמוד יצירת קשר</a>
              </p>
            </div>
          </section>

          <div className="privacy-disclaimer">
            <strong>הבהרה חשובה:</strong>
            <p>
              מסמך זה נועד להציג את מדיניות המשרד ואת תנאי השימוש
              באתר. יש להתאים את הוראותיו לאופן הפעילות בפועל,
              למערכות הטכנולוגיות, לספקים ולנהלי המשרד. פרסום מסמך
              זה אינו מהווה כשלעצמו אישור לעמידה בכל הוראות הדין.
            </p>
          </div>

          <p className="privacy-update-date">
            עודכן לאחרונה: 1 בנובמבר 2026
          </p>
        </div>
      </section>
    </main>
  );
};

export default Privacy_Policy;
